var map = {
	"./atticoLR/atticolr_1_orizzontale.jpg": 8596,
	"./atticoLR/atticolr_2_verticale.jpg": 904,
	"./atticoLR/atticolr_3_orizzontale.jpg": 1584,
	"./atticoLR/atticolr_4_orizzontale.jpg": 2380,
	"./atticoLR/atticolr_5_verticale.jpg": 6100,
	"./brajaFarm/brajafarm_1_orizzontale.jpg": 828,
	"./brajaFarm/brajafarm_2_verticale.jpg": 8388,
	"./brajaFarm/brajafarm_3_verticale.jpg": 5996,
	"./brajaFarm/brajafarm_4_verticale.jpg": 6808,
	"./byro/byro_1_orizzontale.jpg": 5368,
	"./hnHeadquarter/01.jpg": 6312,
	"./hnHeadquarter/02.jpg": 6964,
	"./hnHeadquarter/03.jpg": 9812,
	"./hnHeadquarter/04.jpg": 4180,
	"./hnHeadquarter/05.jpg": 383,
	"./hnHeadquarter/06.jpg": 2303,
	"./leGrange/00_legrange_copertina_mouseover.jpg": 7432,
	"./leGrange/legrange_1_orizzontale.jpg": 3852,
	"./leGrange/legrange_2_verticale.jpg": 4488,
	"./leGrange/legrange_3_verticale.jpg": 692,
	"./leGrange/legrange_4_verticale.jpg": 6616,
	"./leGrange/legrange_5_orizzontale.jpg": 5040,
	"./leGrange/legrange_6_orizzontale.jpg": 4352,
	"./leGrange/legrange_7_orizzontale.jpg": 4892,
	"./leGrange/legrange_8_orizzontale.jpg": 9976,
	"./leGrange/legrange_9_verticale.jpg": 6500,
	"./sidequest/sidequest_1_orizzontale.jpg": 751,
	"./sidequest/sidequest_2_verticale.jpg": 724,
	"./sidequest/sidequest_3_quadrata.jpg": 8604,
	"./villaBardellini/villabardellini_1_orizzontale.jpg": 1744,
	"./villaBardellini/villabardellini_2_verticale.jpg": 3620,
	"./villaBardellini/villabardellini_3_verticale.jpg": 6212,
	"./villaBardellini/villabardellini_4_verticale.jpg": 2108,
	"./villaBardellini/villabardellini_5_verticale.jpg": 4620,
	"./villaBardellini/villabardellini_6_verticale.jpg": 2236,
	"./villaBardellini/villabardellini_7_verticale.jpg": 9944,
	"./villaBardellini/villabardellini_8_verticale.jpg": 2868,
	"./villaMontoro/villamontoro_1_orizzontale.jpg": 8996,
	"./villaMontoro/villamontoro_2_verticale.jpg": 4088,
	"./villaMontoro/villamontoro_3_orizzontale.jpg": 9428,
	"./villaMontoro/villamontoro_4_orizzontale.jpg": 4192,
	"./villaMontoro/villamontoro_5_orizzontale.jpg": 3492
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6688;